import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';
import { UseAxiosResult } from 'axios-hooks';
import { enrichWithCommonLeadValues } from './enrichWithCommonLeadValues';

export const ENDPOINT_PATCH_LEAD = `${backendBaseUrl}/leads`;

export const createOrUpdateLead = (): UseAxiosResult => {
  const { enrich } = enrichWithCommonLeadValues();
  const [{ data, loading, error }, update] = useAxios(
    {
      url: ENDPOINT_PATCH_LEAD,
      withCredentials: true,
      method: 'PATCH',
    },
    { manual: true }
  );

  return [{ data, loading, error }, enrich(update), () => {}];
};
